export class RoutesMapper {
  public static readonly LOGIN: string = 'login';
  public static readonly PRELOGIN: string = 'pre-login';
  public static readonly NEW_DEPOSIT: string = 'new-deposit';
  public static readonly TRANSACTION: string = 'transaction';
  public static readonly MY_FAMILY: string = 'family-members';
  public static readonly UPDATES: string = 'updates';
  public static readonly DEPOSIT_CODES: string = 'deposit-codes';
  public static readonly LANDING_PAGE: string = 'landing-page';
  public static readonly HOME: string = 'home';
  public static readonly ADMIN: string = 'admin';
  public static readonly ALL_TRANSACTION: string = 'all-transaction';
  public static readonly UPDATE_CONTACT: string = 'update-contact';
  public static readonly GENERATE_FC: string = 'generate-fc';
  public static readonly ALL_FC: string = 'all-family-codes';
  public static readonly SUBMIT_ARGHYA: string = 'submit-arghya';
  public static readonly PENDING_FAMILY_CODES: string = 'pending-family-codes';
  public static readonly CANCEL: string = 'cancel';
  public static readonly STATISTICS: string = 'statistics';
  public static readonly GENERATE_FC_USER: string = 'generate-fc-user';
}
